import axios from "axios";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { initializeSocket } from "../../../../utils/socket";
import { useDispatch } from "react-redux";
import { setActiveNavbarTab } from "../../../../../redux-store/slice/activeNavbarSlice";

const useLogin = ({ formData }) => {
  const [loginData, setLoginData] = useState({});
  const [isLoginLoading, setIsLoginLoading] = useState(false);

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const getUser = async (token) => {
    try {
      const res = await axios.get(
        `/api/v1/users`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      return res.data;
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
      }
    }
  };

  const getPermissions = async (token) => {
    try {
      const res = await axios.get(
        `/api/v1/permissions`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "ngrok-skip-browser-warning": "hgs",
          },
        }
      );
      return res.data;
    } catch (error) {
      console.error("Error fetching permissions:", error);
      toast.error("Failed to fetch permissions");
      return null;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setIsLoginLoading(true);
    try {
      const res = await axios.post(
        `/api/v1/auth/login`,
        {
          username: formData.username,
          password: formData.password,
        }
      );
      const token = res.data.token;
      localStorage.setItem("authToken", token);
      setLoginData(res.data);
      initializeSocket(token);
      toast.success("Login successfully !");
      const userData = await getUser(token);
      console.log(userData, "userData");
      // Save user data in sessionStorage
      sessionStorage.setItem("userDetails", JSON.stringify(userData));

      // Fetch and store permissions
      const permissions = await getPermissions(token);
      if (permissions) {
        sessionStorage.setItem("userPermissions", JSON.stringify(permissions));
      }

      // Redirect based on user type
      const userType = userData?.userType;
      console.log(userType, "userType");
      if (userType === "HOSPITALADMIN") {
        dispatch(setActiveNavbarTab("user_management"));
        navigate("/user-management");
      } else if (userType === "MARKETING_USER") {
        dispatch(setActiveNavbarTab("campaign_management"));
        navigate("/campaign");
      } else if (userType === "DOCTOR") {
        dispatch(setActiveNavbarTab("doctor_information_management"));
        navigate("/doctor-information");
      } else if (userType === "DOCTOR_INFO_MANAGEMENT_USER") {
        dispatch(setActiveNavbarTab("hmis_doctor_slot_management"));
        navigate("/hmis-slot-management");
      } else {
        // Default fallback
        dispatch(setActiveNavbarTab("campaign_management"));
        navigate("/campaign");
      }
    } catch (error) {
      console.error(error, "error");
      const errorMessage = error.response?.data?.message;
      if (!error.response) {
        toast.error("Oops, something went wrong");
      } else {
        const messageContent = Array.isArray(errorMessage) ? (
          <ul className="ms-2 list-disc">
            {errorMessage.map((msg, index) => (
              <li key={index}>{msg}</li>
            ))}
          </ul>
        ) : (
          errorMessage || "An unknown error occurred"
        );
        toast.error(messageContent);
      }
    }
    setIsLoginLoading(false);
  };

  return {
    handleSubmit,
    isLoginLoading,
    loginData,
  };
};

export default useLogin;
